export default __webpack_public_path__ + "static/media/errorIcon.36413a6c.svg";